import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Assessment, PostAssessment } from 'src/types/shared/Assessments';

export const postAssessmentRequest = createAction('postAssessmentRequest');
export const postAssessmentSuccess = createAction<Assessment>('postAssessmentSuccess');
export const postAssessmentFailure = createAction('postAssessmentFailure');

export const postAssessment = (assessment: PostAssessment) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(postAssessmentRequest());
    try {
        const { data }: Response = await api.post('admin/assessments', assessment);

        dispatch(postAssessmentSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, postAssessmentFailure, e as any);
    }
};

interface Response {
    data: Assessment;
}
